if (!customElements.get('em-price-savings')) {
  class EmPriceSavings extends HTMLElement {
    connectedCallback() {
      const dataEl = this.querySelector('script[type="application/json"]');
      this.savings = dataEl ? JSON.parse(dataEl.textContent) : {};
      this.valueEl = this.querySelector('.js-em-savings');
      this.productEl = this.closest('.js-product');
      if (!this.productEl) return;

      this.handleVariantChange = (evt) => this.update(evt.detail.variant);
      this.productEl.addEventListener('on:variant:change', this.handleVariantChange);
    }

    disconnectedCallback() {
      if (this.productEl && this.handleVariantChange) {
        this.productEl.removeEventListener('on:variant:change', this.handleVariantChange);
      }
    }

    update(variant) {
      const saving = variant ? this.savings[variant.id] : null;
      this.hidden = !saving;
      if (saving) this.valueEl.innerHTML = saving;
    }
  }

  customElements.define('em-price-savings', EmPriceSavings);
}
